import { Spinner } from "flowbite-react";
import { useTranslation } from "@repo/core";

interface LoadingPerformanceProps {
  className?: string;
}

export const LoadingPerformance = ({ className = "" }: LoadingPerformanceProps) => {
  const { tStrategy } = useTranslation();

  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        {tStrategy("performanceDetailsTitle")}
      </h2>
      <hr className="border-gray-200 mb-6" />
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <Spinner size="xl" />
          <p className="mt-4 text-gray-600">{tStrategy("performanceLoading")}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingPerformance;
